export function formatNumber(value: any) {
  return Number(value).toLocaleString();
}

/**
 * Converts ip address integer to 32 bit IPv4
 *
 * @param {number} upInt
 * @return {string} 32 bit IPv4
 */
export function intToIP(ipInt: number) {
  // eslint-disable-next-line no-bitwise,no-mixed-operators
  return `${ipInt >>> 24}.${ipInt >> 16 & 255}.${ipInt >> 8 & 255}.${ipInt & 255}`;
}

/**
 * Converts numbers to US currency format
 *
 * @param {string|number} price Price in cents
 * @param {bool} longForm Whether or not to include cents if whole dollar amount
 * @return {string} Formatted price, with dollar sign
 */
export function formatCurrency(price: number|string, longForm = false) {
  const numPrice = typeof price === 'string'
    ? parseInt(price, 10)
    : price;
  const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
  if (longForm) {
    return formatter.format(numPrice / 100);
  }
  // Remove cents if '.00'
  return formatter.format(numPrice / 100).replace(/\D00$/, '');
}

/**
 * Remove duplicates from string arrays (up to two dimensions)
 * E.g. ['test', 'test2', 'test', ['test', 'test3'], ['test3', 'test']]
 * => ['test', 'test2', ['test', 'test3']]
 * @param {array} stringArray Array of: strings or array of strings
 * @return {array} Array with duplicates removed
 */
export const removeDuplicatesFromStringArray = (stringArray: Array<string|Array<string>>) => {
  const sortedArray = stringArray.map((facet) => {
    if (Array.isArray(facet)) {
      return facet.sort();
    }
    return facet;
  });
  return [
    ...new Set(
      sortedArray.map((el) => JSON.stringify(el)),
    ),
  ].map((el) => JSON.parse(el));
};
